import type { ConceptDef } from '../types';

export const sortByShape: ConceptDef = {
  kind: 'tileMatch',
  id: 'sort-by-shape',
  label: 'Sort by Shape',
  category: 'Sorting',
  description: 'Hear a shape group; tap an item of that shape.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'something round', answer: '⚽ ball' },
      { say: 'something square', answer: '🧊 ice cube' },
      { say: 'something triangular', answer: '🍕 pizza slice' },
      { say: 'something star-shaped', answer: '⭐ star' },
      { say: 'something heart-shaped', answer: '❤ heart' },
    ],
  },
};
